import styled from "styled-components";

export const Tabela = styled.div`
    width: 100%;
    box-sizing: border-box;
    padding-top: 5px;
    height: calc(100vh - 158px);
    display: flex;
    flex-direction: column;
    gap: 15px;
`;